import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { PoolInterestSubmittedScreenBase } from './PoolInterestSubmittedScreenBase';

export const PoolInterestSubmittedScreen = (): ReactElement => {
  const navigate = useNavigate();
  return <PoolInterestSubmittedScreenBase onDone={() => navigate(-1)} />;
};
